import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function blockTrainersSliderScript() {
    document.addEventListener('DOMContentLoaded', function () {
        const trainersblock = document.querySelectorAll('.trainers-content');

        trainersblock.forEach(block => {
            let trainerPerson = block.querySelectorAll('.splide__slide');
            let arrowStatus = trainerPerson.length;
            let trainer = new Splide(block, {
                type: 'loop',
                perPage: 1,
                gap: 22,
                perMove: 1,
                pagination: false,
                arrows: arrowStatus > 1,
                drag: arrowStatus
            });

            trainer.mount()
        });
    })
}